(function () {
    'use strict';

    angular.module('vouchr.subscribedbrandPage', ['vouchr.vouchrModule', 'vouchr.authModule', 'ui.bootstrap'])
        .config(function(){
        }).run([function(){
        }]);
})();